'use strict';

import 'angular';
import 'angular-messages';
import 'angular-credit-cards';

import RegisterCtrl from './angular/controller/app.register.controller.js';
import AdobeFactory from './angular/service/adobe.service.js';
import RegisterFactory from './angular/service/register.service.js';
import dateError from './angular/directive/dateError.directive.js';
import focusWhen from './angular/directive/focus.directive.js';
import ngBatchIf from './angular/directive/ngBatchIf.directive.js';
import overwriteEmail from './angular/directive/overriteEmail.directive.js';
import CustomSelect from './angular/helpers/country-select.js';
import serverError from './angular/directive/serverError.directive.js';

let checkoutApp = angular
  .module('checkoutApp', [
    'ngMessages',
    'credit-cards',
    require('angular-aria'),
  ])
  .factory('AdobeFactory', AdobeFactory)
  .factory('RegisterFactory', RegisterFactory)
  .factory('CustomSelect', CustomSelect)
  .controller('RegisterCtrl', RegisterCtrl)
  .directive('dateError', dateError)
  .directive('focusWhen', focusWhen)
  .directive('ngBatchIf', ngBatchIf)
  .directive('overwriteEmail', overwriteEmail)
  .directive('serverError', serverError);

checkoutApp.filter('unsafe', [
  '$sce',
  function ($sce) {
    return function (val) {
      return $sce.trustAsHtml(val);
    };
  },
]);
